<template>
    <div class="mobile-tab">
        <div class="search">
            <div style="margin-right: 10px;">
            <div class="custom-dropdown">
                <div class="dropdown-title" @click="toggleDropdown()">
                    <i class="el-icon-location-outline "></i>
                    <span>{{currentcity}}</span>
                </div>
                <div v-show="activeDropdown === index" class="dropdown-content">
                    <div v-for="(subItem, subIndex) in cityList" 
                         :key="subIndex" 
                         v-if="subItem.status"
                         class="dropdown-item"
                         @click="cityClick(subItem,index, subIndex)">
                        {{ subItem.title }}
                    </div>
                    <div v-for="(subItem, subIndex) in cityList" 
                         :key="subIndex" 
                         v-if="!subItem.status"
                         class="dropdown-items"
                         >
                        {{ subItem.title }}
                    </div>
                </div>
            </div>
        </div>
         <el-input placeholder="搜索设备或品牌" v-model="keyword" @change="inputChange"></el-input>
        </div>
        <div class="custom-dropdown-container">
            <div v-for="(item, index) in menuData" :key="index" class="custom-dropdown">
                <div class="dropdown-title" @click="toggleDropdown(index)">
                    <i :class="item.icon"></i>
                    <span>{{ activeItems[index] || item.title }}</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
                <div v-show="activeDropdown === index" class="dropdown-content">
                    <div v-for="(subItem, subIndex) in item.children" 
                         :key="subIndex" 
                         class="dropdown-item"
                         @click="handleItemClick(subItem,index, subIndex)">
                        {{ subItem.title }}
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'MobileTab',
    props:{
        asideData: {
            type: Array,
            default: () => []
        },
        equipmentList: {
            type: Array, 
            default: () => ([]) 
        },
        equipment_id: {
            type: Number,
            default: 0
        },
        supplierBrand: {
            type: Array, 
            default: () => ([]) 
        },
        brand_id: {
            type: Number,
            default: 0
        },
        cityList:{ 
            type: Array, 
            default: function () {
                return [];
            } },
    },
    data() {
        return {
            activeIndex: '1-0',
            activeDropdown: null,
            activeItems: {},
            menuData: [
                {
                    title: '分类',
                    icon: 'el-icon-menu',
                    children: [
                        ...this.asideData
                    ]
                },
                {
                    title: '设备',
                    icon: 'el-icon-menu',
                    children: [
                    ...this.equipmentList
                    ]
                },
                {
                    title: '品牌',
                    icon: 'el-icon-menu',
                    children: [
                        ...this.supplierBrand
                    ]
                }
            ],
            currentcity:'广州',
            keyword:''
        }
    },
    methods: {
         initMenuData() {
            this.menuData = [
                {
                    title: '分类',
                    icon: 'el-icon-menu',
                    children: [...this.asideData]
                },
                {
                    title: '设备',
                    icon: 'el-icon-menu',
                    children: [...this.equipmentList]
                },
                {
                    title: '品牌',
                    icon: 'el-icon-menu',
                    children: [...this.supplierBrand]
                }
            ];
        },
        toggleDropdown(index) {
            this.activeDropdown = this.activeDropdown === index ? null : index;
        },
        handleItemClick(item, index, subIndex) {
            console.log('选中菜单:', item,index, subIndex);
            this.$set(this.activeItems, index, item.title); // 更新选中项
            this.activeDropdown = null;
                if(index===1){
                    this.$emit('selectEquipment',item.id); 
                    this.$set(this.activeItems, 2,'品牌');
                }else if(index===2){
                    this.$emit('selectBrand',item.id);
                }else if(index===0){
                    this.$emit('menu-item-clicked', item); // 触发父组件的事件
                    this.$set(this.activeItems, 2,'品牌');
                }
            // 这里可以添加菜单点击后的处理逻辑
        },
        cityClick(item) {
            this.currentcity = item.title;
            this.activeDropdown = null;
            this.$emit('selectCity', item.city_id);
            // 这里可以添加菜单点击后的处理逻辑
        },
        inputChange(){
            this.$emit('inputChange', this.keyword);
        }

    },
    watch: {
        asideData: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.initMenuData();
                }
            }
        },
        equipmentList: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.initMenuData();
                }
            }
        },
        supplierBrand: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.initMenuData();
                }
            }
        }
    },

}
</script>

<style lang="less" scoped>
.mobile-tab {
    background-color: #fff;
    width: 100%;
    .custom-dropdown-container {
        display: flex;
        width: 100%;
    }
    
    .custom-dropdown {
        flex: 1;
        position: relative;
        text-align: center;
        
        .dropdown-title {
            padding: 12px 0;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #666;
            i {
                margin: 0 5px;
            }
        }
        
        .dropdown-content {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background-color: #fff;
            border: 1px solid #eee;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            z-index: 100;
            max-height: 300px;
            overflow-y: auto;
            color: #666;
            .dropdown-item {
                padding: 10px;
                cursor: pointer;
                &:hover {
                    background-color: #f5f5f5;
                    color: #FF6600;
                }
            }
            .dropdown-items{
                padding: 10px;
                cursor: pointer;
                background-color: #f7f7f7;
                color: #999;
                
            }
        }
    }
    .el-menu-horizontal {
        display: flex;
        width: 100%;
        border-bottom: none;
        
        > .el-submenu {
            flex: 1;
            text-align: center;
            
 
        }
    }
    
    .el-menu--popup {
        max-height: 10em;  // 设置最大高度
        // overflow-y: auto;   // 添加垂直滚动条
        // background-color: #fff;
        
        // .el-menu-item {
        //     white-space: nowrap;
        //     padding: 0 20px;
        // }
    }
    .el-menu--horizontal{
        overflow: hidden;
        overflow-y: auto;   // 添加垂直滚动条
    }
}
/deep/ .el-input__inner {
    height: 3.5em;
    border-radius: 40px;
    font-size: 1.3em;
    background-color: #f7f7f7;
    border: 0;
}
.search {
    display: flex;
    align-items: center;
    // margin:0 10px 10px 10px;
    padding:1em 1em 0;
    background-color: #fff;
    position: relative;
    .city{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
    }
    .el-input {
        // width: 28em;
        font-size: 0.5em;
        flex: 1;
       
    }
    .el-button {
        // width: 1em;
        font-size: 0.9em;
        margin-left: 10px;
        background-color: #FF6600;
        color: #fff;
        border-radius: 5px;
    }

}
</style>